define(function (require, exports, module) {
    'use strict';

    var element = document.createElement('div');

    /**
     * @param {string} html
     * @returns {string}
     */
    function removeHtml(html) {
        element.innerHTML = html;

        var text = element.textContent;

        element.innerHTML = '';

        return text;
    }

    module.exports = removeHtml;
});
